<template>
	<ArkListboxDropdown
		v-model="selection"
		:options="options"
		:label="t('transaction.parking.types')"
		:placeholder="t('transaction.parking.all')"
		:multiple="true"
		:searchable="false"
	/>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import ArkListboxDropdown from "@/components/ui/ArkListboxDropdown.vue"
import { TransactionParkingType } from "@/graphql"

const props = defineProps<{ parkingTypes?: TransactionParkingType[] | null }>()
const emit = defineEmits<{ "update:parkingTypes": [value: TransactionParkingType[]] }>()
const { t } = useI18n()
const options = computed(() =>
	[
		TransactionParkingType.Indoor,
		TransactionParkingType.Outdoor,
		TransactionParkingType.None,
		TransactionParkingType.Unknown,
	].map(value => ({ value, label: t(`transaction.parking.${value}`) }))
)
const selection = computed({
	get: () => props.parkingTypes ?? [],
	set: value => emit("update:parkingTypes", value as TransactionParkingType[]),
})
</script>
